import React from 'react';
import {
  View, Text, StyleSheet, Pressable, Modal,
} from 'react-native';
import FontFamily from '../../../../../constants/fonts';

interface ConfirmCancelModalProps {
  visible: boolean;
  onConfirmDiscard: () => void;
  onGoBack: () => void;
  title?: string;
  message?: string;
  cancelLabel?: string;
  confirmLabel?: string;
}

const ConfirmCancelModal: React.FC<ConfirmCancelModalProps> = ({
  visible,
  onConfirmDiscard,
  onGoBack,
  title = 'Discard changes?',
  message = 'You have unsaved changes. Are you sure you want to discard them?',
  cancelLabel = 'Cancel',
  confirmLabel = 'Confirm',
}) => (
  <Modal visible={visible} transparent animationType="fade">
    <View style={s.backdrop}>
      <View style={s.dialog}>
        <Text style={s.title}>{title}</Text>
        <Text style={s.body}>{message}</Text>
        <View style={s.footer}>
          <Pressable style={s.btnSecondary} onPress={onGoBack}>
            <Text style={s.btnSecondaryText}>{cancelLabel}</Text>
          </Pressable>
          <Pressable style={s.btnPrimary} onPress={onConfirmDiscard}>
            <Text style={s.btnPrimaryText}>{confirmLabel}</Text>
          </Pressable>
        </View>
      </View>
    </View>
  </Modal>
);

const s = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.45)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  dialog: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 24,
    width: '100%',
    maxWidth: 420,
    gap: 12,
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: '#2D2D2D',
    fontFamily: FontFamily.bold,
  },
  body: {
    fontSize: 14,
    color: '#616161',
    lineHeight: 22,
    fontFamily: FontFamily.regular,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 12,
    marginTop: 8,
  },
  btnSecondary: {
    height: 38,
    paddingHorizontal: 20,
    borderRadius: 24,
    borderWidth: 1.5,
    borderColor: '#005CBC',
    alignItems: 'center',
    justifyContent: 'center',
  },
  btnSecondaryText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#005CBC',
    fontFamily: FontFamily.bold,
  },
  btnPrimary: {
    height: 38,
    paddingHorizontal: 20,
    borderRadius: 24,
    backgroundColor: '#005CBC',
    alignItems: 'center',
    justifyContent: 'center',
  },
  btnPrimaryText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#fff',
    fontFamily: FontFamily.bold,
  },
});

export default ConfirmCancelModal;
